import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Alejandro', 'Nicolás', 'Gonzalo', 'Matías', 'Federico', 'Tomás', 'Agustín', 'Santiago', 'Emiliano', 'Joaquín', 'Pablo', 'Andrés', 'Lucas', 'Martín', 'Facundo'];
const CITIES = ['Buenos Aires', 'Rosario', 'Córdoba', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'San Juan'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showPopup();
      // Then set up recurring interval (random between 8-12 seconds)
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * (12000 - 8000 + 1) + 8000));
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-134">
      <div className="bg-white text-gray-900 rounded-lg shadow-2xl p-4 flex items-center gap-4 border-l-4 border-green-500 max-w-sm" data-id="element-135">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-136">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-137" />
        </div>
        <div data-id="element-138">
          <p className="text-sm font-bold" data-id="element-139">
            {currentPurchase.name} de {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-600 mt-0.5" data-id="element-140">
            acaba de comprar este sistema
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-141">Hace unos segundos</p>
        </div>
      </div>
    </div>;
}